<template>
    <div>
        <breadcrumbs />
        <invoices-list show-filters :request-info="requestInfo" />
    </div>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import InvoicesList from '~/components/account/InvoicesList.vue'

    const requestInfo = computed(() => ({
        invoiceType: authStore.isAgency ? 'SUPPLIER' : 'CUSTOMER',
        companyId: authStore.person.companyId,
    }))
</script>
